export enum EUploadImageType {
  CONTRACT = "CONTRACT",
  PROFILE = "PROFILE",
  ORGANIZATION = "ORGANIZATION",
}

export enum ALERT {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  NONE = "NONE",
}

export interface UploadProgress {
  loaded: number;
  total: number;
}

export interface IUploadResult {
  url: string;
  bucket: string;
  key: string;
}
